<template lang="pug">
div 
    alert-modal(ref="confirm" cancelable=true :alertText="alertText" @confirm="confirmConfirmation" @cancel="cancelConfirmation")
    b-button(size='sm', variant='outline-secondary', v-on:click='show', v-if='showButtonVisible')
        | {{config.showButtonHtml}}
    b-modal#basePictureModal.text-sm-left(:ref="'basePictureModal'", centered='', hide-footer='', @hidden="onHidden", @shown="onShown")
        // Header
        template(slot='modal-header')
            .modal-photo-container(v-if="config.showPicture")
                picture-placeholder(:textIn="config.modalTitle" :pictureUrl="config.pictureUrl")
            .modal-toolbar
                block toolbar-buttons
                block modal-toolbar-buttons
                span.modal-btn(v-on:click='hide')
                    i.fi-x.nav-icon 
            h4.modal-title {{config.modalTitle}}
            b-nav.modal-nav-bar(:class="{'modal-nav-bar-no-picture':(!!!config.showPicture)}")
                b-nav-item.modal-nav-link(v-for='(tab,index) in tabs', v-bind:key='tab.title', @click='currentActiveTab=tab.id', :class='{navLinkActive:(tab.id == currentActiveTab)}')  {{tab.title.toUpperCase()}}

        // Content
        div(v-if="'error'==currentActiveTab")
            .tab-load-error Error in Tab Load
        div(v-else)
            block modal-content

    slot(name='button')    
</template>

<script>
import PicturePlaceholder from "@/components/widgets/PicturePlaceholder";

export default {
  name: "BasePictureModal",
  components: {
    PicturePlaceholder,
  },
  props: {
    handleSubmit: Function,
    showButton: Boolean,
  },
  data() {
    return {
      currentActiveTab: "error",
      config: {
        modalTitle: "config_modal_title",
        showButtonHtml: "config_button_text",
        showButton: true,
        showPicture: false,
      },
      tabs: [],
      isEditing: false,
    };
  },
  methods: {
    hide() {
      this.$refs.basePictureModal.hide();
      this.currentActiveTab = this.tabs[0].id;
    },
    show(_event, _record) {
      this.$refs.basePictureModal.show();
      this.$emit("show", _event, _record);
    },
    onHidden() {},
    onShown() {},
    confirmConfirmation() {},
    cancelConfirmation() {},
  },
  computed: {
    showButtonVisible: function () {
      return !!this.config.showButton;
    },
    alertText: function () {
      return "No alert text configured.";
    },
  },
};
</script>

<style lang="scss">
#basePictureModal {
  .modal {
    border-radius: 50px;
    position: fixed;
  }

  .modal-content {
    border-radius: 22px;
    border: none;
  }

  .modal-dialog {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    margin: 0px;
    border-radius: 20px;
    max-width: 650px;
  }

  .modal-header {
    color: white;
    background: #6378a6;
    border: 1px solid #6378a6;
    padding-left: 20px;
    padding-top: 24px;
    height: 147px;
    border-radius: 20px 20px 0px 0px;
    position: relative;
  }

  .modal-nav-bar {
    position: absolute;
    left: 160px;
    bottom: -1px;
  }

  .modal-nav-bar-no-picture {
    left: 20px !important;
  }

  .modal-nav-link {
    width: 100px;
    text-align: center;
    padding: none;
  }

  .modal-toolbar {
    position: absolute;
    right: 0px;
    top: 0px;
    right: 16px;
    top: 16px;
  }

  .navLinkActive a {
    border-bottom: 4px solid orange;
    color: #fff !important;
  }

  .modal-nav-link:hover a {
    border-bottom: 4px solid orange;
    color: #fff !important;
  }

  .modal-nav-link a {
    color: #ddd;
    font-size: 12pt;
    font-weight: 100;
    padding: 5px;
    transition: all 0.15s ease-in-out;
  }

  .modal-body {
    background: #f9f9f9;
    padding-top: 65px;
    border-radius: 0px 0px 20px 20px;
    height: 400px;
    overflow-y: auto;
    position: relative;
  }

  .modal-photo-container {
    background-color: gray;
    height: 128px;
    width: 128px;
    position: absolute;
    left: 20px;
    bottom: 0%;
    transform: translateY(50%);
    border: solid 6px #f9f9f9;
    border-radius: 50%;
    z-index: 1;
    overflow: hidden;
  }

  .hidden {
    display: none;
  }

  .modal-btn {
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: all 0.15s ease-in-out;
  }

  .modal-btn:hover {
    opacity: 0.7;
  }

  .modal-asset-icon {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 32px;
    height: 32px;
  }

  .tab-load-error {
    position: absolute;
    left: 0px;
    top: 50%;
    width: 100%;
    text-align: center;
  }
}
</style>
